import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import api from '../../config/api'

import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from './styles'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

import { useLocation } from 'react-router';
import queryString from 'query-string';
import { useState } from 'react'
import Loading from '../../components/Loading'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        color: '#FFF',
        fontSize: 20,
        fontWeight: 600
    },
}));



const FormSchema = yup.object().shape({
    email: yup.string()
        .required()
        .required('Insira o e-mail')
        .matches(/^[a-zA-Z0-9_.-]+@sicredi+.com+.br+$/i, 'E-mail mal formatado'),

})

interface IFormInputs {
    email: string
}

export default function ResetPassword() {
    const location = useLocation();
    const classes = useStyles();
    const [loading, setLoading] = useState(false)

    const { register, handleSubmit, formState: { errors } } = useForm<IFormInputs>({
        resolver: yupResolver(FormSchema)
    });

    const { email, token } = queryString.parse(location.search);
    console.log(email, token)

    const history = useHistory()

    const handleSubmitForm = async (data: IFormInputs) => {
        setLoading(true)
        try {
            await api.post('users/forgotpass', {
                ...data
            })
            toast.success("Aguarde até 5 minutos para receber seu link de recuperação! 😀")
            history.push('login')
        } catch (err) {
            if (err instanceof Error){
                if (err.message = 'User not found')
                toast.error('E-mail não registrado !')
            }
            else{
                toast.error('Ocorreu algum erro!')
            }
                
        }
        setLoading(false)
    };

    return (
        <Container component="main" maxWidth="xs" >
            <CssBaseline />

            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" align="center">
                    Enviaremos para o seu e-mail um link para recuperar a senha
                </Typography>

                <form className={classes.form} onSubmit={handleSubmit(handleSubmitForm)} >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="email"
                                label="E-mail"
                                {...register('email')}
                                error={errors.email ? true : false}
                                autoComplete="current-password"
                            />
                            {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
                        </Grid>

                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        disabled={loading}
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Enviar e-mail de recuperação
                    </Button>

                </form>
            </div>
        </Container>
    );
}
